import { cn } from '../cn';
import { General } from '../StrokeIcons';

type TeamMismatchBarProps = {
  /** What is being viewed: "contact", "campaign". */
  thing: string;
  /** The team the viewed thing belongs to; omitted when unknown. */
  ownerTeamName?: string | null;
  /** The team the viewer currently has selected. */
  currentTeamName: string;
  className?: string;
};

/**
 * A thin full-width notice that what's on screen belongs to another team than the one selected.
 * Quiet on purpose: it's context, not an error, so it sits as a bar at the top instead of a card.
 */
export function TeamMismatchBar({ thing, ownerTeamName, currentTeamName, className }: TeamMismatchBarProps) {
  return (
    <div
      role="status"
      data-testid="team-mismatch-bar"
      className={cn(
        'flex w-full shrink-0 items-center gap-2 border-b border-amber-200 bg-amber-50 px-4 py-1.5 text-xs text-amber-900',
        'dark:border-amber-900/60 dark:bg-amber-950/40 dark:text-amber-200',
        className,
      )}>
      <General.InfoCircle className="size-3.5 shrink-0" />
      <span className="truncate">
        {ownerTeamName != null && ownerTeamName !== '' && (
          <>
            This {thing} belongs to <span className="font-medium">{ownerTeamName}</span>
          </>
        )}
        {(ownerTeamName == null || ownerTeamName === '') && <>This {thing} belongs to another team</>}
        {' · '}you’re viewing as <span className="font-medium">{currentTeamName}</span>
      </span>
    </div>
  );
}
